import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { PostTradePortfolioAggregate, PostTradePortfolioTotal } from "../Types";
export const GetProposalPostTradeResponse = z.object({
    aggregatedItems: PostTradePortfolioAggregate.array(),
    total: PostTradePortfolioTotal,
});
export const proposalPostTradeUrl = (proposalId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/clientops/v3/proposals/${proposalId}/aggregated-post-trade`
    : `https://middleware.uat.farther.com/clientops/v3/proposals/${proposalId}/aggregated-post-trade`;
export default async function getProposalPostTrade(proposalId, config) {
    const { data } = await axios.get(proposalPostTradeUrl(proposalId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = GetProposalPostTradeResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getProposalPostTrade] returned unexpected data.";
        errorLog(getProposalPostTrade.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getProposalPostTrade.js.map